import { Stack } from 'braid-design-system';
import type React from 'react';

import { ExpireJobForm } from './ExpireJobForm';
import { UpdateExpiryDateFormLoader } from './UpdateExpiryDateFormLoader';

interface ExpireJobDialogContentProps {
  seekAdvertiserId: string;
  jobId: string;
  isCsView: boolean;
  onClose(): void;
}

export const ExpireJobDialogContent: React.FC<
  React.PropsWithChildren<ExpireJobDialogContentProps>
> = ({ seekAdvertiserId, jobId, isCsView, onClose }) => (
  <Stack space="medium">
    <ExpireJobForm
      seekAdvertiserId={seekAdvertiserId}
      jobId={jobId}
      onClose={onClose}
    />

    {isCsView && (
      <UpdateExpiryDateFormLoader
        seekAdvertiserId={seekAdvertiserId}
        jobId={jobId}
        onClose={onClose}
      />
    )}
  </Stack>
);
